<div fxLayoutAlign="center" style="margin-top: 20px;">
  <h2>Please select your payment method below
  </h2>
</div>
<div fxLayoutAlign="center">
  <h4 style="color: black;font-weight:bold">Amount Due : ${{summary?.amount}}
  </h4>
</div>
<div class="row" style="margin-top: 20px;">
  <div class="col-2">
    <button (click)="onOnlinePayment()" mat-raised-button color="primary" style="min-width: 150px">Pay Online</button>
  </div>
  <div class="col-8">
    <h4 style="color: black;font-weight:bold">Pay Online by Credit Card or e-Check</h4>
  </div>
</div>
<div class="row">
    <div class="col-2">
      <button (click)="onMailinPayment()" mat-raised-button color="primary" style="min-width: 150px">Mail In</button>
    </div>
    <div class="col-8">
        <div class="row"><h4 style="color: black;font-weight:bold">Mail Payment into Bureau of Workers' Compensation</h4></div>
        <div class="row">I will  mail in the payment to the address listed below.   
        </div>
    </div>
  </div>

   <div style="color: red;font-weight:bold">Mail To:</div>
   <p style="color: #1b365d;"> Tennessee Bureau of Workers' Compensation<br>
    Exemption Registry<br>
    220 French Landing Suite 1-B<br>
    Nashville, TN 37243<br>
   </p>
